import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Instagram, MessageCircle, BookOpen, Package, Users, ArrowUpRight } from "lucide-react";
import { useSite } from "../context/SiteContext";

export default function Links() {
  const { site } = useSite();

  const items = [
    { to: "/comunidade", label: "Comunidade & Mentoria", desc: "Área de membros exclusiva", icon: Users, testid: "bio-link-comunidade" },
    { to: "/reflexoes", label: "Reflexões", desc: "Um despertar por dia", icon: BookOpen, testid: "bio-link-reflexoes" },
    { to: "/produtos", label: "Produtos", desc: "Ferramentas de evolução", icon: Package, testid: "bio-link-produtos" },
    { href: `https://wa.me/${site.whatsapp}`, label: "WhatsApp", desc: "Fale diretamente comigo", icon: MessageCircle, testid: "bio-link-whatsapp" },
    { href: site.instagram_url, label: "Instagram", desc: "@refllexive", icon: Instagram, testid: "bio-link-instagram" },
  ];

  return (
    <div className="min-h-screen bg-[#050505] font-sans text-zinc-200" data-testid="links-page">
      <div className="grain-overlay" aria-hidden="true" />
      <div className="pointer-events-none fixed inset-0 bg-[radial-gradient(ellipse_at_50%_0%,rgba(212,175,55,0.1),transparent_50%)]" />
      <div className="relative mx-auto flex max-w-lg flex-col items-center px-6 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col items-center"
        >
          <div className="flex h-24 w-24 items-center justify-center rounded-full border-2 border-gold/60 font-serif text-2xl text-gold shadow-[0_0_40px_rgba(212,175,55,0.2)]" data-testid="bio-monogram">
            REF
          </div>
          <h1 className="mt-6 font-serif text-2xl tracking-[0.3em] text-zinc-100">{site.brand_name}</h1>
          <p className="mt-3 text-center text-xs uppercase tracking-[0.25em] text-gold">{site.tagline}</p>
          <p className="mt-4 text-center text-sm text-zinc-400">Para quem quer sair do automático.</p>
        </motion.div>

        <div className="mt-12 flex w-full flex-col gap-4">
          {items.map((item, i) => {
            const Icon = item.icon;
            const inner = (
              <>
                <Icon size={20} className="shrink-0 text-gold" />
                <span className="flex-1 text-left">
                  <span className="block text-sm font-semibold uppercase tracking-[0.15em] text-zinc-100">{item.label}</span>
                  <span className="mt-1 block text-xs text-zinc-500">{item.desc}</span>
                </span>
                <ArrowUpRight size={16} className="text-gold/40 transition-all group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-gold" />
              </>
            );
            const cls = "group flex w-full items-center gap-4 border border-gold/20 bg-[#0a0a0a]/80 px-6 py-5 backdrop-blur transition-all duration-300 hover:-translate-y-0.5 hover:border-gold/50 hover:shadow-[0_0_24px_rgba(212,175,55,0.12)]";
            return (
              <motion.div
                key={item.label}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.15 + i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              >
                {item.to ? (
                  <Link to={item.to} className={cls} data-testid={item.testid}>{inner}</Link>
                ) : (
                  <a href={item.href} target="_blank" rel="noreferrer" className={cls} data-testid={item.testid}>{inner}</a>
                )}
              </motion.div>
            );
          })}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 1 }}
          className="mt-14 font-serif text-gold"
        >
          ✦
        </motion.p>
      </div>
    </div>
  );
}
